<div class="section-banner">
  <h2 class="banner-title">{{ title }}</h2>
  <p *ngIf="subtitle" class="banner-subtitle">{{ subtitle }}</p>
</div>
